import React from 'react';

const BrandLogo = ({
  onClick,
  className = '',
  isDark = false,
  showTagline = true,
  tagline = 'A UNIT OF BRILLIANCE',
  markWidth = 42,
  subTitle = 'Global Solutions',
  title = 'MP-X Global Solutions'
}) => {
  return (
    <div
      className={`mpx-brand-logo notranslate ${isDark ? 'mpx-logo-dark' : ''} ${className}`}
      translate="no"
      onClick={onClick}
      role="button"
      tabIndex={0}
      title={title}
      aria-label={title || "MP-X Global Solutions"}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
          e.preventDefault();
          onClick(e);
        }
      }}
    >
      {/* Vector Animated Mark */}
      <svg
        className="mpx-logo-mark"
        style={{ width: markWidth }}
        viewBox="0 0 1062 880"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id={isDark ? "mpxCyanGradientDark" : "mpxCyanGradient"} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#38e1ff" />
            <stop offset="50%" stopColor="#0cb5d2" />
            <stop offset="100%" stopColor="#0284c7" />
          </linearGradient>
          <filter id={isDark ? "mpxOrbGlowDark" : "mpxOrbGlow"} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="16" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>

        {/* Navy / White 'M' Bridge Structure */}
        <g className="mpx-bridge">
          <path
            d="M 318 760 L 318 245 Q 318 206, 350 206 C 440 230, 520 323, 605 323 C 690 323, 770 260, 808 238 Q 828 226, 828 250 L 828 625 Q 828 643, 802 643 Q 776 643, 776 625 L 776 322 C 730 338, 670 370, 605 370 C 540 370, 460 325, 390 295 L 390 760 Q 390 788, 354 788 Q 318 788, 318 760 Z"
            fill={isDark ? "#ffffff" : "#0e306d"}
          />
        </g>

        {/* Cyan Glowing Orb / Rolling Sphere */}
        <g className="mpx-orb-ambient">
          <circle
            cx="484"
            cy="211"
            r="70"
            fill="#0cb5d2"
            opacity="0.25"
            filter={`url(#${isDark ? 'mpxOrbGlowDark' : 'mpxOrbGlow'})`}
          />
          <circle
            cx="484"
            cy="211"
            r="64"
            fill={`url(#${isDark ? 'mpxCyanGradientDark' : 'mpxCyanGradient'})`}
          />
          <circle
            cx="466"
            cy="192"
            r="16"
            fill="#ffffff"
            opacity="0.65"
          />
        </g>
      </svg>

      {/* Typography Text Column */}
      <div className="mpx-brand-text notranslate" translate="no">
        <div className="mpx-title-row notranslate" translate="no">
          <span className="mpx-main-title notranslate" translate="no">MP-X</span>
          <span className="mpx-divider"></span>
          <span className="mpx-sub-title notranslate" translate="no">{subTitle}</span>
        </div>
        {showTagline && (
          <div className="mpx-tagline notranslate" translate="no">{tagline}</div>
        )}
      </div>
    </div>
  );
};

export default BrandLogo;
